import { RequestStatus } from "./RequestStatus";

export interface SessionState {
  isAuthenticated: boolean;
  isSessionConfirmed: boolean;
  twoFAUpdateStatus: RequestStatus;
  status: SessionStatus;
  embedToken: string;
  otpAuthUrl: string | null;
  credentials?: any;
  twoFactorAuthEnabled: boolean;
  twoFactorValidated: RequestStatus;
  loginRequestStatus: RequestStatus;
}

export enum SessionStatus {
  initial = "initial",
  waitingTwoFactorAuth = "waitingTwoFactorAuth",
  fulfilled = "fulfilled",
  logOut = "logOut",
}
